import { Notification } from 'element-ui';
import { Event } from '@/api/product';
export default class message {
  constructor() {
    this.timer = null;
    this.duration = 4500;
    this.ext = {};
    this.expression = {
      TriFormula: '',
      RecFormula: ''
    };
    this.triggerKey = [];
    this.recoverKey = [];
  }

  // 处理接收的消息
  async handleMessageFn(data) {
    let { type, ext, message } = data;

    if (ext) {
      ext = JSON.parse(ext);
      this.ext = ext;
      await this.getProductEvent();
      this.createNotice(ext);
    } else {
      let isMonitorView = location.href.includes('monitorMaintenance');
      if (isMonitorView) {
        this.removeNotice();
        this.createNoticeSystem(type, message);
        this.handleAddListenMonitorFn();
        this.addTimer();
      } else {
        // 非自定义通知样式
        let obj = {
          1: '系统通知',
          2: '设备告警',
          3: '告警恢复',
          4: '设备故障',
          5: '故障恢复',
          6: '流量预警',
          7: '空间预警',
          8: '短信预警'
        };
        if (type !== 9) {
          Notification({
            title: obj[type],
            message,
            position: 'bottom-right',
            dangerouslyUseHTMLString: true
          });
        }
      }
    }
  }

  // 创建自定义通知
  createNotice(ext) {
    this.removeNotice();

    let isMonitorView = location.href.includes('monitorMaintenance');
    if (isMonitorView) {
      this.createNoticeMonitor(ext);
      this.handleAddListenMonitorFn();
    } else {
      this.createNoticeCommon(ext);
      this.handleAddListenCommonFn();
    }

    this.addTimer();
  }

  // 创建自定义通知-后台
  createNoticeCommon(ext) {
    let handleType = {
      1: '告警',
      2: '故障',
      3: '报表'
    };
    let handleLevel = {
      LowLow: '轻度',
      Low: '一般',
      High: '严重',
      HighHigh: '紧急'
    };

    // 触发时间
    let createDate = ext.CreatedAt.substr(0, 19).replace('T', ' ');
    // 等级
    let levelText = handleLevel[ext.expression_level] + handleType[ext.type];
    // 背景色
    let bgClass = '';
    // 恢复图片
    let imgEl = '';
    // 触发条件
    let triggerEl = '';

    // 恢复
    if (ext.json2) {
      bgClass = 'bg-normal';
      imgEl = `<img
        src="/imgs/normal.png"
        class="noraml-img"
      >`;

      if (this.expression.RecConfirmMode === 1) {
        triggerEl = `<p>${this.expression.RecFormula}</p>`;
      } else {
        if (this.expression.RecConfirmMode === 0) {
          triggerEl = `<p>非触发条件</p>`;
        }
      }
      let el = '';
      for (let i = 0; i < this.recoverKey.length; i++) {
        let item = this.recoverKey[i];
        el += `<p>${item.Name} [${item.CtlName}-${item.KeyName}] = ${item.val}</p>`;
      }
      triggerEl += el;
    } else {
      // 告警 / 故障
      if (ext.type === 1) {
        bgClass = 'bg-alarm';
      } else {
        bgClass = 'bg-falut';
      }
      imgEl = '';

      triggerEl = `<p>${this.expression.TriFormula}</p>`;
      let el = '';
      for (let i = 0; i < this.triggerKey.length; i++) {
        let item = this.triggerKey[i];
        el += `<p>${item.Name} [${item.CtlName}-${item.KeyName}] = ${item.val}</p>`;
      }
      triggerEl += el;
    }

    let el = document.createElement('div');
    el.setAttribute('id', 'noticeAlertBox');
    el.classList.add('notice-alert-box');
    el.classList.add(bgClass);
    setTimeout(() => {
      el.classList.add('show');
    }, 0);

    let html = `<div class="notice-header">
        <div class="header-left">
          <span class="type-text">${levelText}</span>
          <span class="title">${ext.name}</span>
        </div>
        <div class="header-close" id="closeNoticeAlertBox">
          <img src="/imgs/close.png">
        </div>

        ${imgEl}
      </div>
      <div class="notice-body">
        <div class="item">
          <span class="label">设备名称：</span>
          <span class="label-content">${ext.device_name}</span>
        </div>
        <div class="item">
          <span class="label">触发时间：</span>
          <span class="label-content">${createDate}</span>
        </div>
        <div class="item">
          <span class="label">触发条件：</span>
          <div class="label-content">
            ${triggerEl}
          </div>
        </div>
      </div>
    `;
    el.innerHTML = html;
    document.querySelector('body').appendChild(el);
  }

  // 创建自定义通知-监控
  createNoticeMonitor(ext) {
    let handleType = {
      1: '告警',
      2: '故障',
      3: '报表'
    };
    let handleLevel = {
      LowLow: '轻度',
      Low: '一般',
      High: '严重',
      HighHigh: '紧急'
    };

    // 触发时间
    let createDate = ext.CreatedAt.substr(0, 19).replace('T', ' ');
    // 等级
    let levelText = handleLevel[ext.expression_level] + handleType[ext.type];
    // 背景色
    let bgClass = '';
    // 恢复图片
    let imgEl = '';
    // 触发条件
    let triggerEl = '';

    // 恢复
    if (ext.json2) {
      bgClass = 'bg-normal';
      imgEl = `<img
        src="/imgs/normal.png"
        class="noraml-img"
      >`;

      if (this.expression.RecConfirmMode === 1) {
        triggerEl = `<p>${this.expression.RecFormula}</p>`;
      } else if (this.expression.RecConfirmMode === 0) {
        triggerEl = `<p>非触发条件</p>`;
      }
      let el = '';
      for (let i = 0; i < this.recoverKey.length; i++) {
        let item = this.recoverKey[i];
        el += `<p>${item.Name} [${item.CtlName}-${item.KeyName}] = ${item.val}</p>`;
      }
      triggerEl += el;
    } else {
      // 告警 / 故障
      if (ext.type === 1) {
        bgClass = 'bg-alarm';
      } else {
        bgClass = 'bg-falut';
      }
      imgEl = '';

      triggerEl = `<p>${this.expression.TriFormula}</p>`;
      let el = '';
      for (let i = 0; i < this.triggerKey.length; i++) {
        let item = this.triggerKey[i];
        el += `<p>${item.Name} [${item.CtlName}-${item.KeyName}] = ${item.val}</p>`;
      }
      triggerEl += el;
    }

    let el = document.createElement('div');
    el.setAttribute('id', 'noticeAlertMonitorBox');
    el.classList.add('notice-alert-monitor-box');
    el.classList.add(bgClass);
    setTimeout(() => {
      el.classList.add('show');
    }, 0);

    let html = `<div class="notice-header">
        <div class="header-left">
          <span class="type-text">${levelText}</span>
          <span class="title">${ext.name}</span>
        </div>
        <div class="header-close" id="closeNoticeAlertMonitorBox">
          <img src="/imgs/close.png">
        </div>

        ${imgEl}
      </div>
      <div class="notice-body">
        <div class="item">
          <span class="label">设备名称：</span>
          <span class="label-content">${ext.device_name}</span>
        </div>
        <div class="item">
          <span class="label">触发时间：</span>
          <span class="label-content">${createDate}</span>
        </div>
        <div class="item">
          <span class="label">触发条件：</span>
          <div class="label-content">
            ${triggerEl}
          </div>
        </div>
      </div>
    `;
    el.innerHTML = html;
    document.querySelector('body').appendChild(el);
  }

  // 创建自定义通知-系统通知
  createNoticeSystem(type, message) {
    let obj = {
      1: '系统通知',
      2: '设备告警',
      3: '告警恢复',
      4: '设备故障',
      5: '故障恢复',
      6: '流量预警',
      7: '空间预警',
      8: '短信预警'
    };

    let el = document.createElement('div');
    el.setAttribute('id', 'noticeAlertMonitorBox');
    el.classList.add('notice-alert-monitor-box');
    el.classList.add('bg-notice');
    setTimeout(() => {
      el.classList.add('show');
    }, 0);

    let html = `<div class="notice-header">
        <div class="header-left">
          <span class="type-text">${obj[type]}</span>
        </div>
        <div class="header-close" id="closeNoticeAlertMonitorBox">
          <img src="/imgs/close.png">
        </div>
      </div>
      <div class="notice-body">
        <p class="notice-msg">${message}</p>
      </div>
    `;
    el.innerHTML = html;
    document.querySelector('body').appendChild(el);
  }

  // 移除自定义通知元素
  removeNotice() {
    this.removeNoticeCommon();
    this.removeNoticeMonitor();
  }

  // 移除自定义通知-后台
  removeNoticeCommon() {
    let el = document.querySelector('#noticeAlertBox');
    if (el) {
      el.classList.remove('show');
      document.querySelector('body').removeChild(el);
    }
  }

  // 移除自定义通知-监控
  removeNoticeMonitor() {
    let el = document.querySelector('#noticeAlertMonitorBox');
    if (el) {
      el.classList.remove('show');
      document.querySelector('body').removeChild(el);
    }
  }

  // 添加定时器
  addTimer() {
    this.clearTimer();
    this.timer = setTimeout(() => {
      this.removeNotice();
    }, this.duration);
  }

  // 清除定时器
  clearTimer() {
    if (this.timer) {
      clearTimeout(this.timer);
      this.timer = null;
    }
  }

  // 事件监听-后台
  handleAddListenCommonFn() {
    let closeEl = document.querySelector('#closeNoticeAlertBox');
    closeEl.addEventListener('click', () => {
      this.removeNotice();
    });

    let noticeEl = document.querySelector('#noticeAlertBox');

    noticeEl.addEventListener('mouseenter', () => {
      this.clearTimer();
    });

    noticeEl.addEventListener('mouseleave', () => {
      this.addTimer();
    });
  }

  // 事件监听-监控
  handleAddListenMonitorFn() {
    let closeEl = document.querySelector('#closeNoticeAlertMonitorBox');
    closeEl.addEventListener('click', () => {
      this.removeNotice();
    });

    let noticeEl = document.querySelector('#noticeAlertMonitorBox');

    noticeEl.addEventListener('mouseenter', () => {
      this.clearTimer();
    });

    noticeEl.addEventListener('mouseleave', () => {
      this.addTimer();
    });
  }

  // 获取产品事件
  getProductEvent() {
    return new Promise(resolve => {
      Event({
        produceId: this.ext.produce_id
      }).then(res => {
        let eventProduct = res.data.find(item => item.identification === this.ext.identification);
        switch (this.ext.expression_level) {
          case 'LowLow':
            this.expression = JSON.parse(eventProduct.expression_1);
            break;
          case 'Low':
            this.expression = JSON.parse(eventProduct.expression_2);
            break;
          case 'High':
            this.expression = JSON.parse(eventProduct.expression_3);
            break;
          case 'HighHigh':
            this.expression = JSON.parse(eventProduct.expression_4);
            break;
        }
        // 触发变量
        const jsonEventDetail = JSON.parse(this.ext.json);
        const keys = JSON.parse(eventProduct.variable);
        let triggerKey = [];
        for (let v of jsonEventDetail.CalcVars.Events.Vars) {
          const match = keys.find(item => item.CtlNode === v.CtrlNode && item.KeyNode === v.Name);
          match &&
            triggerKey.push({
              val: v.Value,
              ...match
            });
        }
        this.triggerKey = triggerKey;
        // 恢复变量
        if (this.ext.json2 !== '') {
          const json2EventDetail = JSON.parse(this.ext.json2);
          let recoverKey = [];
          for (let v of json2EventDetail.CalcVars.Events.Vars) {
            const match = keys.find(item => item.CtlNode === v.CtrlNode && item.KeyNode === v.Name);
            match &&
              recoverKey.push({
                val: v.Value,
                ...match
              });
          }
          this.recoverKey = recoverKey;
        }

        resolve();
      });
    });
  }
}
